var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-page-header',{attrs:{"title":"返回","content":(_vm.content + " - " + (_vm.workOrder.workOrderNo) + "/" + (_vm.workOrder.displayName))},on:{"back":function($event){return _vm.$router.back()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }